import { cn } from "utils";
import { ospThemes } from "@ospweb/sdk-ui";
import { useMemo } from "react";
import { calculateChangeRate } from "../table/stock/columns/type";
import { PriceColumn } from "../table/dashboard/columns/items/Price";
import NextImage from "../NextImage";
import { Tag } from "./Tag";
import { StockResult } from "@/src/hooks/useStockDashboard";
import { OpenDataTokenResult } from "@/src/hooks";
import { CRYPTO_THEME_LABELS } from "@/src/componentsv1";

export const Crypto = ({
  data,
  disableSummary = false,
  type,
}: {
  data: OpenDataTokenResult & StockResult;
  disableSummary?: boolean;
  type?: "crypto" | "hk-stocks" | "us-stocks";
}) => {
  // 使用 useMemo 缓存所有计算结果
  const { value: formattedValue, color: textColorClass } = useMemo(() => {
    const currentPrice = Number(data?.trading_data?.current_price);
    const previousClose = Number(data?.trading_data?.previous_close);
    const calculatedResult = calculateChangeRate(currentPrice, previousClose);
    return calculatedResult;
  }, [data?.trading_data?.current_price, data?.trading_data?.previous_close]);
  return (
    <div className="gap-3 p-3 rounded-xl cursor-pointer">
      <div className="flex items-center justify-between h-full">
        <div className="flex items-center gap-2 min-w-0 flex-1">
          <NextImage
            src={data.socials?.image_url || data.logo || ""}
            width={32}
            height={32}
            className="rounded-full"
            alt={data.symbol || ""}
          />
          <div className="flex flex-col min-w-0">
            <div
              className="body_medium_m text-content_primary truncate"
              title={data?.short_name || data?.symbol}
            >
              {data?.short_name || data?.symbol}
            </div>
            <div
              className="body_s text-content_tertiary overflow-hidden text-ellipsis whitespace-nowrap mt-0.5"
              title={data.name}
            >
              {data.name}
            </div>
          </div>
        </div>
        <div className="flex flex-col items-end gap-1">
          {type === "crypto" && (
            <>
              <PriceColumn
                record={data}
                index={0}
                panelType={CRYPTO_THEME_LABELS.blueChip}
                sortBy="vol_24h"
                fontColor={ospThemes.colors.content_primary}
              />
              <Tag value={data.trade?.price_change_24h || "0"} />
            </>
          )}
          {(type === "hk-stocks" || type === "us-stocks") && (
            <>
              <div className="flex flex-col items-end">
                <span className="body_medium_m text-content_primary block mb-0.5">
                  {!!data?.trading_data?.current_price
                    ? `$${data?.trading_data?.current_price}`
                    : "--"}
                </span>
                <div className={cn("body_medium_s", textColorClass)}>
                  {formattedValue}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      {!disableSummary && (
        <div
          className="body_s text-content_tertiary line-clamp-2"
          title={data?.summary || ""}
        >
          {data?.summary || ""}
        </div>
      )}
    </div>
  );
};
